import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ModalController, PopoverController, Events, LoadingController, AlertController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { MonedaPage } from '../moneda/moneda';
/**
 * Generated class for the CategoriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-factura',
  templateUrl: 'factura.html',
})
export class FacturaPage {
  factura: any = {}
  loadModal: any
  path:string=this.http.images
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public navParams: NavParams, 
    public loadingCtrl: LoadingController,
    public popCtrl: PopoverController,
    public events : Events,
    public http: HttpProvider,
    public viewCtrl: ViewController,
    public modal: ModalController
    ) {
    events.subscribe('moneda:update', ()=>{
      this.updateMoneda()
    })
    this.ActivarLoading()
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
    let nro_doc = this.navParams.get('factura')
    if(window.localStorage.getItem('network') === '1'){
      this.http.get(`factura/${nro_doc}`).subscribe(
        (res:any)=>{
          const factura = {
            ...res[0]
          }
          // if (factura.co_mone === "USD   ") {
          //   factura.saldo = factura.saldo * parseFloat(window.localStorage.cambio)
          //   factura.total_neto = factura.total_neto * parseFloat(window.localStorage.cambio)
          //   for (let i = 0; i < factura.items.length; i++) {
          //     factura.items[i].prec_vta = factura.items[i].prec_vta  * parseFloat(window.localStorage.cambio)
          //     factura.items[i].reng_neto = factura.items[i].reng_neto * parseFloat(window.localStorage.cambio)
          //   }
          // }
          this.factura = factura
          this.DesactivarLoading()
        },
        error=>{
          this.DesactivarLoading()
          console.log(error)
        }
      )
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  transform2(value: string, tasa) {
    if(value){
      let val
      let valor = parseFloat((parseFloat(value) / parseFloat(tasa)).toFixed(2))
      val = valor
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }
  
  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  close(){
    this.viewCtrl.dismiss()
  }

}


// WEBPACK FOOTER //
// ./src/pages/factura/factura.ts